<template>
  <div
    class="homework-content-info"
    :class="getPagination.pageCount === 1 ? 'pb-4' : 'pb-3'"
  >
    <!-- CONTENT CARD COMPONENT -->
    <HomeworkBlock
      v-for="(homework, index) in getCompletedHomewrk"
      :key="index"
      :assessment_id="Number(homework.id)"
      :date="homework.close_date"
      :title="homework.title"
      :subject="homework.subject.name"
      :percent="homework.score"
      :isTaken="homework.is_taken"
      :isClosed="homework.is_closed"
      :status="homework.status"
      :see_answer="homework.can_see_answer"
      :see_score="homework.can_see_answer"
      :score="Number(homework.correctQuestions)"
      :total="Number(homework.countAttemptedQuestions)"
    />
    <!-- CONTENT CARD COMPONENT -->

    <!-- PAGINATION COMPONENT -->
    <div class="position-relative" style="top: -5px">
      <Pagination
        v-if="old_pagination && getPagination.pageCount > 1"
        :paging="getPagination"
        @navigatePage="$emit('switchPage', $event)"
      />
    </div>
    <!-- PAGINATION COMPONENT -->
  </div>
</template>

<script>
export default {
  name: "SchoolworkCompletedContent",

  props: {
    completed_homework: [Array, Object],
    old_pagination: Object,
  },

  components: {
    HomeworkBlock: () =>
      import(
        /* webpackChunkName: "HomeworkBlock" */ "@/components/profileComps/studentprofile/HomeworkBlock"
      ),
    Pagination: () =>
      import(
        /* webpackChunkName: "Pagination" */
        "@/components/globalComps/Pagination"
      ),
  },

  computed: {
    getPagination() {
      return this.old_pagination;
    },

    getCompletedHomewrk() {
      return this.completed_homework;
    },
  },
};
</script>

<style lang="scss" scoped>
.homework-content-info {
  margin-top: 10px;
  //   margin-bottom: 40px;

  @include breakpoint_max(md) {
    // margin-bottom: 90px;
  }
}
</style>
